module.exports = __webpack_public_path__ + "static/media/31GalleryPuppets.b073d9c1.jpeg";